import React, { useEffect } from "react";
import {
  Container,
  Row,
  Col,
  InputGroup,
  Button,
  Card,
  CardBody,
  Label,
} from "reactstrap";
import { useSafariPaymentReset } from "../../hooks/useSafariPaymentReset";
import CustomInput from "../../custom/CustomInput";
import CustomSelect from "../../custom/CustomSelect";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as actions from "../../redux/creators";
import * as Yup from "yup";
import { useSelector, useDispatch, batch } from "react-redux";
import CircularLoading from "../loader/CircularIndeterminate";
import { Autocomplete, TextField } from "@mui/material";

const Voga = () => {
  const dispatch = useDispatch();
  const { isPostLoading } = useSelector((state) => state.coursereg);
  // const { courses } = useSelector((state) => state.courses);
  const { courseByEvents, isLoading } = useSelector(
    (state) => state.courseByEvents
  );

  // Reset loading state when returning from payment (iOS Safari fix)
  useSafariPaymentReset();

  const defaultProps = {
    options: courseByEvents,
    getOptionLabel: (option) => option.name,
  };
  const data = {
    id: "15",
  };
  useEffect(() => {
    dispatch(actions.courseByEventsGetData(data));
  }, []);

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    const coursereg = {
      clientname: values.clientname,
      clientemail: values.clientemail,
      clientphone: values.clientphone,
      age: values.age,
      years_of_training: values.years_of_training,
      client_message: values.client_message,
      course_id: values.course_id,
      totalfees: values.totalfees,
      preferred_time: values.preferred_time,
      is_enquiry: values.is_enquiry,
      is_online_payment: values.is_online_payment,
    };
    // iOS Safari compatible redirect
    dispatch(
      actions.postCourseregDataWithBackendRedirect(coursereg, setSubmitting, resetForm)
    );
    setSubmitting(true);
    return;
  };
  return (
    <React.Fragment>
      <Container>
        <div className="bg-white">
          <Row>
            <h5 className="text-center p-3">
              Please fill the form to register for batches.
            </h5>
          </Row>
          <Card>
            <CardBody>
              <Formik
                initialValues={{
                  clientname: "",
                  clientemail: "",
                  clientphone: "",
                  age: "",
                  years_of_training: "",
                  client_message: "",
                  course_id: "",
                  preferred_time: "",
                  totalfees: "0",
                  is_enquiry: "0",
                  is_online_payment: "1",
                }}
                onSubmit={handleSubmit}
                validationSchema={Yup.object().shape({
                  clientemail: Yup.string()
                    .required("Enter Your Email")
                    .email("Invalid Email address"),
                  clientname: Yup.string().required("required"),
                  clientphone: Yup.string().required("required"),
                  course_id: Yup.string().required("required"),
                })}
              >
                {(formProps) => (
                  <Form className="mt-3">
                    {console.log("formProps", formProps.values)}
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="clientname" className="label">
                          Your Full Name:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientname"
                            id="clientname"
                            placeholder="Enter Your Name"
                            className={
                              "form-control" +
                              (formProps.errors.clientname &&
                                formProps.touched.clientname
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientname"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="clientemail" className="label">
                          Your Email:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientemail"
                            id="clientemail"
                            placeholder="Enter Your Email"
                            className={
                              "form-control" +
                              (formProps.errors.clientemail &&
                                formProps.touched.clientemail
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientemail"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="clientphone" className="label">
                          Your Mobile Number:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="clientphone"
                            id="clientphone"
                            placeholder="Enter Your Mobile Number"
                            className={
                              "form-control" +
                              (formProps.errors.clientphone &&
                                formProps.touched.clientphone
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="clientphone"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="age" className="label">
                          Your Age:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="age"
                            id="age"
                            placeholder="Enter Your Age"
                            className={
                              "form-control" +
                              (formProps.errors.age && formProps.touched.age
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="age"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="years_of_training" className="label">
                          Years of Classical Training:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="years_of_training"
                            id="years_of_training"
                            placeholder="Years of Classical Training"
                            className={
                              "form-control" +
                              (formProps.errors.years_of_training &&
                                formProps.touched.years_of_training
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="years_of_training"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="client_message" className="label">
                          Why do you want to join Voga?
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            name="client_message"
                            id="client_message"
                            placeholder="Why do you want to join Voga?"
                            className={
                              "form-control" +
                              (formProps.errors.client_message &&
                                formProps.touched.client_message
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="client_message"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="course_id" className="label">
                          Your Course:
                        </Label>
                        <InputGroup>
                          <Autocomplete
                            {...defaultProps}
                            id="course_id"
                            name="course_id"
                            getOptionSelected={(option, value) =>
                              option.id === value.id
                            }
                            onChange={(event, newValue) => {
                              formProps.setFieldValue(
                                `course_id`,
                                newValue?.id ?? ""
                              );
                              formProps.setFieldValue(
                                `totalfees`,
                                newValue?.total_amount ?? ""
                              );
                            }}
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Course Name *"
                                variant="outlined"
                                name="course_id"
                                size="small"
                                className="form-control"
                                error={
                                  formProps.touched.course_id &&
                                  Boolean(formProps.errors.course_id)
                                }
                                helperText={
                                  formProps.touched.course_id &&
                                  formProps.errors.course_id
                                }
                              />
                            )}
                          />
                        </InputGroup>
                      </Col>
                      <Col md={6}>
                        <Label htmlFor="totalfees" className="label">
                          Your Amount:
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomInput}
                            type="text"
                            disabled
                            name="totalfees"
                            id="totalfees"
                            placeholder="Enter Amount"
                            className={
                              "form-control" +
                              (formProps.errors.totalfees &&
                                formProps.touched.totalfees
                                ? " is-invalid"
                                : "")
                            }
                          />

                          <ErrorMessage
                            name="totalfees"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={6}>
                        <Label htmlFor="preferred_time" className="label">
                          Select Time Slot
                        </Label>
                        <InputGroup>
                          <Field
                            component={CustomSelect}
                            type="select"
                            name="preferred_time"
                            id="preferred_time"
                            placeholder="Select Time Slot"
                            className={
                              "form-control" +
                              (formProps.errors.preferred_time &&
                                formProps.touched.preferred_time
                                ? " is-invalid"
                                : "")
                            }
                          >
                            <option value={""}>Select Time</option>
                            <option value={"7am -8am IST"}>7am -8am IST</option>
                            <option value={"5pm -6pm IST"}>5pm -6pm IST</option>
                          </Field>
                          <ErrorMessage
                            name="client_message"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <Row className="form-group mt-3">
                      <Col md={12}>
                        <InputGroup>
                          <Field type="checkbox" name="checked" value="One" />

                          <span className="radiobtn">
                            {" "}
                            &nbsp; Hereby,Please Accept Terms & Condition
                          </span>
                          <ErrorMessage
                            name="branch"
                            component="div"
                            className="invalid-feedback"
                          />
                        </InputGroup>
                      </Col>
                    </Row>
                    <h4 className="text-center p-3 mt-3">
                      To register for Voga Experience (Level 1), Kindly contact
                      us at +91 7400 377748
                    </h4>
                    <div className="mt-3 mb-3 row mt-3">
                      <div className="col-12">
                        <Button
                          type="submit"
                          className="register-btn"
                          size="md"
                          block
                        >
                          {isPostLoading ? <CircularLoading /> : "PAY NOW"}
                        </Button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </CardBody>
          </Card>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Voga;
